import React from 'react';

import {CircularProgress} from "@mui/joy";
import Link from "@mui/joy/Link";
import Chip from "@mui/joy/Chip";

// components
import BaseApi from "../../utils/BaseApi";
import OpportunityMiniCard from "../Opportunity/OpportunityMiniCard";
import OpportunityFullCard from "../Opportunity/OpportunityFullCard";

// icons
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import {retrieveCommentXtypes} from "../Comment/CommentSidebar";


class OpportunityCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opportunity: this.props.opportunity,
            comments: this.props.comments,
            delivery_states: this.props.delivery_states,
            my_roles: this.props.my_roles,
        }
    }

    async retrieveComments(listXtypes) {
        const url = 'comment/';
        const params = {
            related_app: 'Opportunity',
            related_app_id: this.props.opportunityID,
            xtype: listXtypes,
            deleted_bool: 0,
            page_size: 3,
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params,
            'repeat'
        );
        return response.data.results
    }

    async retrieveOpportunity() {
        const url = 'opportunity/' + this.props.opportunityID + '/card/';
        const api = new BaseApi();
        let response = await api.get(url, {});
        let comments = [];
        if (!this.props.mini && !this.props.nano){
            let [xtypes, mateXtypes] = await retrieveCommentXtypes(
                'Opportunity',
                this.props.opportunityID
            )
            comments = await this.retrieveComments(mateXtypes)
        }
        this.setState({
            opportunity: response.data.opportunity,
            comments: comments,
            delivery_states: response.data.delivery_states,
            my_roles: response.data.my_roles,
        });
    }

    async componentDidMount() {
        if (!this.state.opportunity){
            await this.retrieveOpportunity();
        }
    }

    render() {
        if (!this.state.opportunity) {
            return (<CircularProgress/>)
        }
        return (
            <>
                {
                    this.props.nano?
                        <Chip
                            startDecorator={<LocalOfferIcon />}
                            sx={this.props.sx?this.props.sx:{}}
                        >
                            <Link
                                href={'/opportunity/detail/'+this.state.opportunity.id}
                                target={'_blank'}
                                fontSize={'small'}
                            >
                                {this.state.opportunity.short_name}
                            </Link>
                        </Chip>:
                        null
                }
                {
                    this.props.mini?
                        <OpportunityMiniCard
                            opportunity={this.state.opportunity}
                            delivery_states={this.state.delivery_states}
                            showDeliveryStates={this.props.showDeliveryStates}
                            my_roles={this.state.my_roles}
                            callBack={this.props.callBack}
                            extraModules={this.props.extraModules}
                            color={this.props.color}
                            selected={this.props.selected}
                            width={this.props.width}
                            mlPermission={this.props.mlPermission}
                        />:
                        null
                }
                {
                    !this.props.mini && !this.props.nano ?
                        <OpportunityFullCard
                            opportunity={this.state.opportunity}
                            comments={this.state.comments}
                            delivery_states={this.state.delivery_states}
                            my_roles={this.state.my_roles}
                            color={this.props.color}
                            retrieveOpportunity={this.retrieveOpportunity.bind(this)}
                            width={this.props.width}
                        />:
                        null
                }
            </>
        )
    }
}

export default OpportunityCard;
